import React, { useState } from "react";
import LandingPage from "./LandingPage";
import OptInMessagePage from "./OptInMessagePage";
import { parse } from "qs";
import PropTypes from "prop-types";

export default function Sports(props) {
  const [submitted, updateSubmitted] = useState(false);

  // Get the referral code from the query params to include on form submit
  const queryParams = parse(props.location.search.slice(1));
  const referralCode = queryParams.code || "";
  return (
    <div>
      {submitted ? (
        <OptInMessagePage />
      ) : (
        <LandingPage
          updateSubmitted={updateSubmitted}
          referralCode={referralCode}
        />
      )}
    </div>
  );
}

Sports.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
